module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "listContainer",
    staticClass: "yzh-box",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "yzh-user"
  }, [_c('img', {
    staticClass: "yzh-user-avatar",
    attrs: {
      "src": _vm.data.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yzh-user-info"
  }, [_c('span', {
    staticClass: "yzh-user-name"
  }, [_vm._v(_vm._s(_vm.data.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "yzh-user-id"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))]), _vm._v(" "), _c('div', {
    staticClass: "yzh-user-fan"
  }, [_c('span', {
    staticClass: "yzh-user-fan-item"
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhu')) + "： "), _c('span', {
    staticClass: "yzh-user-fan-num"
  }, [_vm._v(_vm._s(_vm.data.followCount || 0))])]), _vm._v(" "), _c('span', {
    staticClass: "yzh-user-fan-item"
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')) + "： "), _c('span', {
    staticClass: "yzh-user-fan-num"
  }, [_vm._v(_vm._s(_vm.data.vermicelliCount || 0))])])])]), _vm._v(" "), (!_vm.isSelf) ? _c('div', {
    staticClass: "yzh-user-follow",
    class: {
      'yzh-user-follow--active': _vm.data.isFollowHe === 1
    },
    on: {
      "click": _vm.toggleFollow
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.data.isFollowHe === 1 ? _vm.$t('all.yiguanzhu') : _vm.$t('all.guanzhuta')) + "\n\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appConfigInfo && _vm.appConfigInfo.videoStatus == 1) ? _c('div', {
    staticClass: "yzh-video"
  }, [_c('div', {
    staticClass: "yzh-video-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shipin')) + " " + _vm._s(_vm.videoList.length))]), _vm._v(" "), (_vm.videoList.length > 0) ? _c('div', {
    staticClass: "yzh-grid"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.videoId || index,
      staticClass: "yzh-card",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [(item.coverUrl) ? _c('img', {
      staticClass: "yzh-card-cover",
      attrs: {
        "src": item.coverUrl
      }
    }) : _c('div', {
      staticClass: "yzh-card-cover yzh-card-cover--empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-mask"
    }, [_c('div', {
      staticClass: "yzh-card-likes"
    }, [_c('img', {
      staticClass: "yzh-card-likes-icon",
      attrs: {
        "src": _vm.dzIcon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "yzh-card-likes-num"
    }, [_vm._v(_vm._s(item.giveLikeNumber || 0))])]), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-title"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('div', {
      staticClass: "yzh-card-meta"
    }, [_c('span', {
      staticClass: "yzh-card-duration"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.videoLoading && _vm.loaded && _vm.videoList.length === 0) ? _c('kong') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-243e9278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/yonghuzhuye/yonghuzhuye.vue
// module id = 1003
// module chunks = 1